exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_integrations_3KKkWHjxFVpu05S8b6x1ES {\n  width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_integrations": "IA_integrations_3KKkWHjxFVpu05S8b6x1ES"
};